
import * as z from "zod";

// Contact form schema with validation
export const contactFormSchema = z.object({
  name: z.string().min(2, { message: "Naam moet minstens 2 karakters bevatten" }),
  company: z.string().min(1, { message: "Bedrijfsnaam is verplicht" }),
  email: z.string().email({ message: "Ongeldig e-mailadres" }),
  phone: z.string().min(5, { message: "Telefoonnummer is verplicht" }),
  message: z.string().optional(),
  source: z.string().optional(),
  website: z.string().optional(), // Honeypot field
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
